import { Link } from 'react-router-dom';
import s from './Navbar.module.scss';
import { FC, PropsWithChildren } from 'react';
import { LogoImage } from '@/assets';
import { Card } from '@tremor/react';

export const NavbarLayout: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Card className={[s.appBarContainer, 'border-b-[1px] border-b-gray-300'].join(' ')}>
      <Link to="/" className={s.logoContainer}>
        <img className="h-12" src={LogoImage} alt="marchemy logo" />
      </Link>
      <span className="inline-flex items-center px-2 py-0.5 text-xs font-semibold bg-gradient-to-r from-blue-100 to-purple-100 text-blue-800 border border-blue-200 rounded-full shadow-sm mr-auto">
        BETA
      </span>
      {children}
    </Card>
  );
};
